<template>
  <component
    v-bind="$attrs"
    :class="span"
    :is="as"
  >
    <slot name="default" />
  </component>
</template>

<script>
import { computed } from 'vue';

export default {
  inheritAttrs: false,
  props: {
    as: {
      type: String,
      default: 'div',
    },
    width: {
      type: String,
      default: '1/1',
    },
  },
  setup(props) {
    const span = computed(() => ({
      '1/1': 'xl:col-span-12',
      '3/4': 'xl:col-span-9',
      '2/3': 'xl:col-span-8',
      '1/2': 'xl:col-span-6',
      '1/3': 'xl:col-span-4',
      '1/4': 'xl:col-span-3',
      '1/6': 'xl:col-span-2',
      '1': 'xl:col-span-1',
      '2': 'xl:col-span-2',
      '3': 'xl:col-span-3',
      '4': 'xl:col-span-4',
      '5': 'xl:col-span-5',
      '6': 'xl:col-span-6',
      '7': 'xl:col-span-7',
      '8': 'xl:col-span-8',
      '9': 'xl:col-span-9',
      '10': 'xl:col-span-10',
      '11': 'xl:col-span-11',
      '12': 'xl:col-span-12',
    }[props.width]));

    return {
      span,
    }
  }
}
</script>
